import { isAfter, parseISO, startOfDay } from 'date-fns';

// Gets start of day at midnight - parses ISO dates automatically
export function getStartOfDay(date: string | Date): Date {
	const _date = typeof date === 'string' ? parseISO(date) : date;
	const _startOfDay = startOfDay(_date);
	return _startOfDay;
}

// Formats date if provided as ISO string, returns as Date object
export function formatDate(date: string | Date): Date {
	return typeof date === 'string' ? parseISO(date) : date;
}

// Is the current Date after the provided date? - parses ISO dates automatically
export const isNowAfter = (date: string | Date): boolean => {
	const formattedDate = formatDate(date);
	return isAfter(new Date(), formattedDate);
};

interface TimeArrayProps {
	interval?: number;
	startTime?: number;
}

export const timeArrayGenerate = ({ interval = 60, startTime = 0 }: TimeArrayProps) => {
	const x = interval; //minutes interval
	const times = []; // time array
	let tt = startTime; // start time
	const ap = ['AM', 'PM']; // AM-PM

	//loop to increment the time and push results in array
	for (let i = 0; tt < 24 * 60; i++) {
		const hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
		const mm = tt % 60; // getting minutes of the hour in 0-55 format
		times[i] = ('' + (hh === 0 || hh === 12 ? 12 : hh % 12)).slice(-2) + ':' + ('0' + mm).slice(-2) + ' ' + ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
		tt = tt + x;
	}
	return times;
};
